export default "https://yastatic.net/s3/frontend/vconf-frontend/_/phone.1d8cf5bb.svg";